import React from 'react'

import bannerSlices from '../../images/hero_area/banner_slices2.png'
import logo from '../../images/logo.png'

const Heading = () => (
  <section className="hero-area">
    <div className="banner-item">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="banner-content-wrap">
              <p
                className="banner-info wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="500ms"
              >
                2020/1/25(Sat) 11:30- @豊洲フロント
              </p>
              <h1
                className="banner-title wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="700ms"
              >
                <img src={logo} alt="SRE NEXT" />
                2020
                <br />
                in Tokyo
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="tiles">
      <div className="tile" data-scale="1.1" data-image={bannerSlices} />
    </div>
  </section>
)

export default Heading
